// latest: zhangmyh 2017-2-23 7:33 PM
import { Model } from 'common'

Model.define('evalgroup.refer', {
  proxy: {},
  meta: {
    id: '',
    name: '',
    parentId: ''
  }
})

export default Model.create('evalgroup.refer')



// WEBPACK FOOTER //
// ./src/data/model/evaluationGroup/evalGroupRefer.js